import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { PrivateRoutes } from "./PrivateRoutes.tsx";
import { PublicRoutes } from "./PublicRoutes.tsx";
import React, { useEffect, useState } from "react";
import { LOGIN_STATUS, NO_TOKEN } from "../utils/Constants.tsx";
import { useDispatch, useSelector } from "react-redux";
import {
  checkAuthentication,
  updateRefreshTime,
  updateScreen,
} from "../redux/slices/loginApiSlice.ts";
import { toast } from "react-toastify";
import Login from "../pages/login/Login.tsx";
function useRouteInfo() {
  const location = useLocation();
  const path = location.pathname.replace("/", "");

  const [searchParams] = useSearchParams();
  const time = searchParams.get("time");
  return { path, time };
}
function AppRoute() {
  const [redirect, setRedirect] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const routeInfo = useRouteInfo();
  useEffect(() => {
    localStorage.setItem("time", String(new Date().getTime()));
    dispatch(checkAuthentication());
  }, [dispatch]);

  useEffect(() => {
    dispatch(updateScreen(routeInfo?.path));
    const isLogout = localStorage.getItem("logout") === "true";
    if (routeInfo?.path.includes("noc") && !isLogout) {
      localStorage.setItem("noc", "true");
    }
    localStorage.removeItem("logout");

    if (routeInfo?.time) {
      dispatch(updateRefreshTime(Number(routeInfo?.time)));
    }
  }, [routeInfo]);

  const { status } = useSelector((state: any) => state.login);

  const authStatus = localStorage.getItem("AUTH_STATUS") ?? status;
  useEffect(() => {
    const redirect = localStorage.getItem("redirect") === "true";
    setRedirect(redirect);
    const savedTime = Number(localStorage.getItem("time") || 0);
    const AUTH_TOKEN = localStorage.getItem("AUTH_TOKEN");
    const newTime = new Date().getTime();
    const diff = newTime - savedTime;
    if (
      diff > 10000 &&
      authStatus !== LOGIN_STATUS.AUTHENTICATED &&
      (!AUTH_TOKEN || AUTH_TOKEN !== NO_TOKEN)
    ) {
      toast.error("API token has expired!");
      navigate("/login");
    }
  }, [authStatus]);

  return (
    <Routes>
      {authStatus === LOGIN_STATUS.AUTHENTICATED && (
        <Route path="/*" element={<PrivateRoutes screen={routeInfo?.path} />} />
      )}
      {authStatus !== LOGIN_STATUS.AUTHENTICATED && (
        <Route path="/*" element={<PublicRoutes redirect={redirect} />} />
      )}
    </Routes>
  );
}

export default AppRoute;
